import React, {useEffect, useState} from 'react';
import {Spinner} from "react-bootstrap";

import MainStore from "../../store/MainStore";

import NRUForm from "./NRUForm";
import ERPForm from "./ERPForm";
import CUA2Form from "./CUA2Form";
import NRUPROForm from "./NRUPROForm";
import NRUEXPERTForm from "./NRUEXPERTForm";
import DPUForm from "./DPUForm";
import PADDUCForm from "./PADDUCForm";
import CUB2Form from "./CUB2Form";
import RU2Form from "./RU2Form";
import RU2FormDemo from "./RU2FormDemo";
import CUA2FormDemo from "./CUA2FormDemo";
import CUB2FormDemo from "./CUB2FormDemo";


const FormWrarper = (props) => {

    const [logoB64, setLogoB64]=useState()
    const [stampB64, setStampB64]=useState()




    useEffect(()=>{
        (MainStore.getState().MeReducer.entity_logo_b64)?setLogoB64(MainStore.getState().MeReducer.entity_logo_b64):null;
        (MainStore.getState().MeReducer.entity_stamp_b64)?setStampB64(MainStore.getState().MeReducer.entity_stamp_b64):null;


    }, [])


    useEffect(()=>{
        (MainStore.getState().MeReducer.entity_logo_b64)?setLogoB64(MainStore.getState().MeReducer.entity_logo_b64):null;
        (MainStore.getState().MeReducer.entity_stamp_b64)?setStampB64(MainStore.getState().MeReducer.entity_stamp_b64):null;
    },[MainStore.getState().MeReducer.entity_stamp_b64, MainStore.getState().MeReducer.entity_logo_b64])

   useEffect(()=>{
   },[MainStore.getState().FormsReducer.saveFormData])

    const renderForm=()=>{
        $(".swal2-modal").css('width', '700px');
        $('.swal2-popup').css('width', '700px');
        if(props?.level==="demo"){
            switch(props.formSelect){
                case 'cua' :
                    return <CUA2FormDemo level={props?.level} logob64={logoB64} stampb64={stampB64} dataForm={null} demInfo={props.demInfo}/>;
                case 'cub' :
                    return <CUB2FormDemo level={props?.level} logob64={logoB64} stampb64={stampB64}  dataForm={null} demInfo={props.demInfo} />;
                case 'ru' :
                    return <RU2FormDemo level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null} demInfo={props.demInfo} />;
                default: return <div><h4>Pas de formulaire disponible</h4></div>
            }
        }else{
            switch(props.formSelect){
                case 'nru':
                    return <NRUForm level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null} demInfo={props.demInfo}/>;
                case 'dpu' :
                    return <DPUForm level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null} addressBien={props.addressBien}/>;
                case 'nrupro':
                    return <NRUPROForm level={props?.level} screenCapt={props.screenCapt} dataForm={null}/>;
                case 'nruexp':
                    return <NRUEXPERTForm level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null}/>;
                case 'padduc':
                    return <PADDUCForm level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null}/>;
                case 'erp':
                    return <ERPForm level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null}/>;
                case 'ru' :
                    return <RU2Form level={props?.level} logob64={logoB64} stampb64={stampB64}  screenCapt={props.screenCapt} dataForm={null} demInfo={props.demInfo} />;
                case 'cua' :
                    return <CUA2Form level={props?.level} logob64={logoB64} stampb64={stampB64} dataForm={null} demInfo={props.demInfo}/>;
                case 'cub' :
                    return <CUB2Form level={props?.level} logob64={logoB64} stampb64={stampB64}  dataForm={null} demInfo={props.demInfo} />;
                default: return <div><h4>Pas de formulaire disponible</h4></div>
            }
        }
    }

    return (
        <div className={'shadow rounded px-3 py-4 ue-form-wrapper-content'}
             style={{
                 "minHeight":"650px",
                 "maxHeight": "650px",
                 "fontSize": "0.72rem",
                 "overflowY": "auto",
                 "overflowX": "hidden"
             }}
             id={'form-dem-data'}>

            {
              renderForm()
            }
        </div>
    );
};


export default FormWrarper
